import React, { Fragment } from "react";
import { Table } from "react-bootstrap";
import { Days } from "../../../../../_helpers/Helpers";

export function Timetable({
  tableType,
  headers,
  courseHours,
  timetable
}) {
  return (
    <Table responsive striped bordered hover>
      <thead>
        <tr>
          <th className="text-center" style={{width: "8%"}}>Haftaiçi</th>
          {
            Days.map((day, i) => <th key={i} className="text-center" style={{width: "12%"}}>{day}</th>)
          }
          <th className="text-center" style={{width: "8%"}}>Haftasonu</th>
        </tr>
      </thead>
      <tbody>
        {
          headers.map(header => {
            const table = tableType === "section" ? timetable.filter(table => table.sectionId === header.value) :
                          tableType === "teacher" ? timetable.filter(table => table.teacherId === header.value) : [];

            return (
              <Fragment key={header.value}>
                <tr>
                  <th colSpan={9} className="text-center" style={{backgroundColor: "aliceblue"}}>{header.label}</th>
                </tr>
                {
                  courseHours.map(hour => 
                    <tr key={hour.courseHour}>
                      <th className="text-center align-middle">
                        {hour.courseHour}. Ders
                        <br />
                        {hour.weekdayStartHour.slice(0, 5)}
                        <br />
                        {hour.weekdayEndHour.slice(0, 5)}
                      </th>
                      {
                        Days.map((day, i) => {
                          const tableInThisDayAndHour = table.find(table => table.day === i + 1 && table.hour === hour.courseHour);
                          const firstName = tableType === "section" ? tableInThisDayAndHour?.courseName : 
                                            tableType === "teacher" ? tableInThisDayAndHour?.sectionName : "";
                          const secondName = tableType === "section" ? tableInThisDayAndHour?.teacherName : 
                                            tableType === "teacher" ? tableInThisDayAndHour?.courseName : "";

                          return (
                            <td key={i} className="text-center align-middle">
                              {firstName}
                              <br />
                              <b>{secondName}</b>
                            </td>
                          )
                        })
                      }
                      <th className="text-center align-middle">
                        {hour.courseHour}. Ders
                        <br />
                        {hour.weekendStartHour.slice(0, 5)}
                        <br />
                        {hour.weekendEndHour.slice(0, 5)}
                      </th>
                    </tr>
                  )                  
                }
              </Fragment>
            )
          })
        }
      </tbody>
    </Table>
  );
}